import Reveal from './Reveal';

/** Eyebrow + H2 on the left, short aside paragraph bottom-right. */
export default function SectionHeading({
  id, eyebrow, eyebrowClass = 'text-accent-700', title, titleClass = 'text-h2',
  aside, asideClass = '', className = '',
}) {
  return (
    <Reveal className={`flex flex-wrap items-end justify-between gap-x-10 gap-y-6 ${className}`}>
      <div>
        {eyebrow && <div className={`eyebrow ${eyebrowClass}`}>{eyebrow}</div>}
        <h2 id={id} className={`${eyebrow ? 'mt-4' : ''} max-w-[820px] balance ${titleClass}`}>{title}</h2>
      </div>
      {aside && <p className={`max-w-[380px] text-body pretty ${asideClass}`}>{aside}</p>}
    </Reveal>
  );
}
